// Features: M004-F0807 (WebUI #270, slice M2a: the read-only "Update available" badge)
// Tests: T-M004-0467 (see CalendarUpdateList.test.js beside this file).
//
// Read-only. One proposal.list call (state pending, limit 1) for the pending_count. Hidden, with NO request, unless the view gate
// is on AND the user can manage the Ledger (ledger_manage). Loading and error render nothing; a stale count is never shown.
import React, { useEffect, useState } from 'react';
import { calendarUpdateApi } from '../../../services/calendarUpdateApi';
import { CALENDAR_UPDATE_VIEW_ENABLED, badgeLabel } from './calendarUpdateModel';

export default function CalendarUpdateBadge({
  orgId, canManage, viewEnabled = CALENDAR_UPDATE_VIEW_ENABLED, api = calendarUpdateApi,
}) {
  const [count, setCount] = useState(null);
  const active = Boolean(viewEnabled && canManage);

  useEffect(() => {
    if (!active) return undefined;
    let cancelled = false;
    setCount(null);
    api.list(orgId, { state: 'pending', limit: 1 })
      .then((res) => { if (!cancelled) setCount(res?.data?.data?.pending_count ?? null); })
      .catch(() => { if (!cancelled) setCount(null); });
    return () => { cancelled = true; };
  }, [active, orgId, api]);

  const label = active && count !== null ? badgeLabel(count) : null;
  if (!label) return null;
  return <span className="calendar-update-badge" role="status">{label}</span>;
}
